import { render, staticRenderFns } from "./CeurImagingEdge.vue?vue&type=template&id=fe866b2c"
import script from "./CeurImagingEdge.vue?vue&type=script&lang=js"
export * from "./CeurImagingEdge.vue?vue&type=script&lang=js"
import style0 from "./CeurImagingEdge.vue?vue&type=style&index=0&id=fe866b2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports